(function ($) {
    $('.search-toggle,.menu-item-search-toggle').on('click', function (e) {
        $('#searchform').slideToggle();
    });
})(jQuery);